function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTargetRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.036 9.593l-2.18.934 3.405 3.405 2.179-.935-3.404-3.404zm2.49-3.736l-.933 2.179 3.404 3.405.935-2.18-3.406-3.404zM8.758 16.542L2 9.784l4.459-1.911-1.666-1.666 1.414-1.414 1.666 1.666L9.784 2l6.758 6.758-1.868 4.359 3.001 3.001a1.1 1.1 0 11-1.557 1.557l-3.001-3.001-4.359 1.868z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4c-.748 0-1.476.077-2.19.198l3.982 3.982A9 9 0 118.18 18.792l-3.982-3.98A13.044 13.044 0 004 17c0 7.18 5.82 13 13 13s13-5.82 13-13S24.18 4 17 4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.896 19.998a3.083 3.083 0 01-2.192-.908l-2.044-2.044-2.559 1.097c.546 3.321 3.423 5.857 6.9 5.857a7 7 0 007-7c0-3.477-2.538-6.353-5.859-6.898l-1.097 2.558 2.044 2.044c.585.586.91 1.364.91 2.192 0 .83-.325 1.608-.91 2.193a3.082 3.082 0 01-2.193.91z",
    fill: props.color
  }));
}

export default SvgIconTargetRexFilled;